/* eslint-disable */
export const environment = {
  api: {
      host: process.env.REACT_APP_API_HOST,
      geoLocationService: process.env.REACT_APP_API_GEOLOCATION_HOST,
      customerService: process.env.REACT_APP_API_CUSTOMER_HOST,
      policyService: process.env.REACT_APP_API_POLICY_HOST,
      claimService: process.env.REACT_APP_API_CLAIMS_HOST,
      authService: process.env.REACT_APP_API_AUTH_HOST
  },
  localApiAuth: {
    apiUrls: process.env.REACT_APP_API_ALLOWED_HOSTS?.split("|") ?? []
  },
  settings:{
    numberOfInceptionDays: 180,
    vagDocumentCategory: parseInt(process.env.REACT_APP_VAG_CATEGORY_ID || "0")
  }
}